import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "app/store";
import setupLocalStorageAPI from "utils/setupLocalStorageAPI";

interface SectionSideMenuState {
  collapsiblePanel: {
    visible: boolean;
    animationInProgress: string;
  };
}

const sidePanelVisibleStorage = setupLocalStorageAPI("sidePanelVisible");

const initialState: SectionSideMenuState = {
  collapsiblePanel: {
    visible: sidePanelVisibleStorage.getData(true),
    animationInProgress: ""
  }
};

const sectionSideMenu = createSlice({
  name: "section-side-menu",
  initialState,
  reducers: {
    toggleSidePanel(state) {
      const newValue = !state.collapsiblePanel.visible;
      state.collapsiblePanel.visible = newValue;
      sidePanelVisibleStorage.updateData(newValue);
      state.collapsiblePanel.animationInProgress = newValue ? "show" : "hide";
    },
    collapseSidePanelPanel(state) {
      const newValue = false;
      state.collapsiblePanel.visible = newValue;
      sidePanelVisibleStorage.updateData(newValue);
      state.collapsiblePanel.animationInProgress = "";
    },
    sidePanelStopAnimation(state) {
      state.collapsiblePanel.animationInProgress = "";
    }
  }
});

export const selectCollapsiblePanel = (state: RootState) =>
  state.sectionSideMenu.collapsiblePanel;

export const {
  toggleSidePanel,
  sidePanelStopAnimation,
  collapseSidePanelPanel
} = sectionSideMenu.actions;

export default sectionSideMenu.reducer;
